<template>
  <section id="situation" class="pb-8 pt-10">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="9" xl="9">
              <div class="text-center mt-4">
                <h1 class="section-title font-weight-light">Выберите свою ситуацию</h1>
              </div>
            </v-col>
          </v-row>

          <v-row align="center" justify="space-around" class="mt-6">
            <v-col cols="12" md="12" xl="12">
              <v-carousel class="situation-carousel" hide-delimiters>
                <template v-for="(item, index) in slides">
                  <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index">
                    <v-row class="flex-nowrap" style="height:100%">
                      <template v-for="(n,i) in columns">
                        <template v-if="(+index + i) < slides.length">
                          <v-col :key="i" class="situation-panel">

                            <v-sheet v-if="(+index + i) < slides.length" height="100%" elevation="2">
                              <v-row class="text-center" align="center" justify="center">
                                <v-col xs="12">
                                  <v-img :eager="true" :src="slides[+index + i].img" max-width="100px"
                                         class="d-block ml-auto mr-auto"></v-img>
                                </v-col>
                              </v-row>
                              <v-row class="text-center" align="center" justify="center">
                                <v-col xs="12">
                                  <h1 class="title font-weight-regular">{{ slides[+index + i].title }}</h1>
                                  <p class="description" v-html="slides[+index + i].description"></p>
                                  <p>
                                    <span class="price">{{ slides[+index + i].price }}</span>
                                    <span class="price-crossed text-decoration-line-through">
                                      {{ slides[+index + i].crossedPrice }}
                                    </span>
                                  </p>

                                  <v-btn v-if="slides[+index + i].crossedPrice" class="call-btn-3" @click="selectSituation(slides[+index + i].title)">{{ slides[+index + i].btnText }}</v-btn>
                                  <v-btn v-else class="call-btn-3" @click="$vuetify.goTo('#dialog')">{{ slides[+index + i].btnText }}</v-btn>
<!--                                  <p>-->

<!--                                    <span class="price">{{ slides[+index + i].price }}</span>-->
<!--                                    <span class="price-crossed text-decoration-line-through">-->
<!--                                      {{ slides[+index + i].crossedPrice }}-->
<!--                                    </span>-->
<!--                                  </p>-->
<!--                                  <p class="text-center">-->
<!--                                    <ycassaBtn v-if="slides[+index + i].priceValue"-->
<!--                                               :customer-number="`Получение декларации: ${slides[+index + i].title}`" btn-text="Получить декларацию"-->
<!--                                               :price-value="slides[+index + i].priceValue"></ycassaBtn>-->
<!--                                    <v-btn v-else class="call-btn-3" @click="$root.$emit('show-dialog')">{{ slides[+index + i].btnText }}</v-btn>-->
<!--                                  </p>-->
                                </v-col>
                              </v-row>
                            </v-sheet>

                          </v-col>
                        </template>
                      </template>
                    </v-row>
                  </v-carousel-item>
                </template>
              </v-carousel>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>

export default {
  name: "situation",
  data: () => ({
    slides: [
      {
        img: require("@/assets/image/dom.png"),
        title: 'Купили квартиру или дом',
        description: 'Вернем до <span class="bold-text">260 000 ₽</span> за покупку квартиры или строительство дома',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию',
      },
      {
        img: require("@/assets/image/ipoteka.png"),
        title: 'Платили за ипотеку',
        description: 'Вернем до <span class="bold-text">390 000 ₽</span> за уплаченные проценты по ипотеке',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию'
      },
      {
        img: require("@/assets/image/lecenie.png"),
        title: 'Платили за лечение',
        description: 'Вернем до <span class="bold-text">13%</span> в год от расходов на медицинские услуги за себя, супруга (-и), родителей и детей до 18 лет',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию'
      },
      {
        img: require("@/assets/image/obucenie.png"),
        title: 'Платили за обучение',
        description: 'Вернем до <span class="bold-text">15 600 ₽</span> в год за оплату своего обучения и до <span class="bold-text">6 500 ₽</span> за оплату обучения каждого ребенка до 24 лет',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию'
      },
      {
        img: require("@/assets/image/investicii.png"),
        title: 'Открыли инвестиционный счет',
        description: 'Вернем до <span class="bold-text">52 000 ₽</span> в год по взносам на индивидуальный инвестиционный счет',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию'
      },
      {
        img: require("@/assets/image/strahov.png"),
        title: 'Платили за страхование жизни',
        description: 'Вернем до <span class="bold-text">15 600 ₽</span> в год за оплату страхования жизни за себя, супруга (-и), родителей и детей',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию'
      },
      {
        img: require("@/assets/image/nedvij.png"),
        title: 'Продали недвижимость',
        description: 'Законно <span class="bold-text">уменьшим или освободим от уплаты  налога</span> при продаже недвижимости',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию'
      },
      {
        img: require("@/assets/image/car.png"),
        title: 'Продали автомобиль',
        description: 'Законно <span class="bold-text">уменьшим или освободим от уплаты  налога</span> при продаже автомобиля',
        price: '790 ₽',
        priceValue: "790",
        crossedPrice: "990 ₽",
        btnText: 'Заказать декларацию'
      },
      {
        img: require("@/assets/image/inaya.png"),
        title: 'Иная ситуация',
        description: 'Не нашли свою ситуацию? Задайте вопрос эксперту',
        priceValue: null,
        price: 'Бесплатно',
        crossedPrice: null,
        btnText: 'Получить консультацию'
      },

    ]
  }),
  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 3;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 3;
      }

      if (this.$vuetify.breakpoint.md) {
        return 2;
      }

      return 1;
    }
  },
  methods: {
    selectSituation(situation) {
      this.$root.$emit('set-request-situation', situation);
      this.$vuetify.goTo('#request');
    },
  }
};
</script>

<style lang="scss">
$main_color: #283e79;

.situation-carousel {
  .v-carousel__controls {
    padding-top: 20px;
    background: transparent;

    .theme--dark.v-btn.v-btn--icon {
      background: #005096 !important;

      i {
        display: none;
      }
    }
  }

  .theme--dark.v-btn.v-btn--icon {
    background: #005096 !important;
  }

  .v-window__next {
    margin-left: 10px;
  }
}

.situation-panel {
  padding: 26px;

  .title {

  }

  .bold-text {
    font-weight: bold;
  }

  .description {
    text-align: center;
    font-size: 16px;
    margin: 10px;
    padding: 30px;
  }
}

@media (max-width: 1700px) {
  .situation-panel {
    padding: 30px;


    .description {
      font-size: 13px;
      margin: 10px;
      padding: 30px;
    }
  }
}
</style>